import { Button, Flex, Typography } from "antd";
import React, { useState } from "react";
import { roleandpermissions } from "../../services";
import { showCustomMessage } from "./constant";
import { AppModal } from "../../components/common";

type Props = {
  openModal: boolean;
  setOpenModal: (openModal: boolean) => void;
  singleData: any;
  refreshData: () => void;
};

export default function UserRemoveModal({
  openModal,
  setOpenModal,
  singleData,
  refreshData,
}: Props): JSX.Element {
  const [loader, setLoader] = useState<boolean>(false);
  const removeUser = (id: string) => {
    setLoader(true);
    roleandpermissions
      .deleteUserRole(id)
      .then((res: any) => {
        setLoader(false);
        refreshData();
        setOpenModal(false);
        showCustomMessage("removed");
      })
      .catch((err: any) => {
        setLoader(false);
      });
  };

  const footer = (
    <>
      <Button onClick={() => setOpenModal(false)}>Cancel</Button>
      <Button
        type="primary"
        loading={loader}
        onClick={() => removeUser(singleData._id)}
      >
        Remove
      </Button>
    </>
  );

  return (
    <AppModal
      footer={footer}
      className="userRemoveModal"
      open={openModal}
      onCancel={() => setOpenModal(false)}
    >
      <Flex vertical gap={8} align="center" justify="center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="64"
          height="64"
          viewBox="0 0 20 20"
        >
          <path
            fill="#F87A36"
            d="M8.681 2.785c.568-1.047 2.071-1.047 2.638 0l6.5 12.002A1.5 1.5 0 0 1 16.502 17H3.498a1.5 1.5 0 0 1-1.319-2.215zM10.5 7.5a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0zm.25 6.25a.75.75 0 1 0-1.5 0a.75.75 0 0 0 1.5 0"
          />
        </svg>
        <Typography.Text>Please Confirm</Typography.Text>
        <p className="confirmText">
          {`Are you sure you want to remove ${singleData?.full_name} from the role of ${singleData?.user_type}?`}
        </p>
        <Flex vertical className="noteSection">
          <p>Note:</p>
          <Typography.Paragraph>
            This action will revoke all permissions associated with this role
            for the user. This change cannot be undone.
          </Typography.Paragraph>
        </Flex>
      </Flex>
    </AppModal>
  );
}
